/* Kuba Frete — cálculo de preço e prazo (PAC/SEDEX, contrato Correios) por CEP.
 * Sem dependências. Dados: frete_kuba.min.json (gerado por coletar_frete.py).
 *
 * Uso (lib):   KubaFrete.load(url).then(f => f.calcular("01310-100", 450))
 * Uso (widget): KubaFrete.mount(el, { dataUrl, peso, valorPedido, freteGratisAcima, diasPreparo, diasExtra, avisoPrazo, margem })
 *   freteGratisAcima: valor a partir do qual o PAC é grátis (SEDEX é sempre pago)
 *   diasPreparo: dias úteis somados a todo prazo (padrão 2) · diasExtra: dias por produto (montagem, pré-venda)
 *   avisoPrazo: texto opcional que substitui o status (ex.: "Pré-venda: entrega em até 60 dias")
 *   textoEncomenda: status quando diasExtra > 0 (padrão "Montado à mão pra você")
 *   margem: acréscimo de segurança sobre o preço (padrão 0.05 = 5%)
 *   oficina: true quando o produto é montado/preparado pela Kuba (fala em "oficina"); false pra itens de terceiros
 *   disponivel: função/booleano — false esconde o widget (variante esgotada)
 */
(function (root) {
  "use strict";

  function normalizaCep(cep) {
    var d = String(cep || "").replace(/\D/g, "");
    return d.length === 8 ? d : null;
  }
  function brl(v) {
    return "R$ " + v.toFixed(2).replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
  // a base dos Correios vem sem acentos; corrige as palavras mais comuns
  var ACENTOS = { sao: "São", vitoria: "Vitória", brasilia: "Brasília", goiania: "Goiânia", florianopolis: "Florianópolis", cuiaba: "Cuiabá",
    macapa: "Macapá", belem: "Belém", maceio: "Maceió", joao: "João", luis: "Luís", ribeirao: "Ribeirão", niteroi: "Niterói", jose: "José",
    goncalo: "Gonçalo", uberlandia: "Uberlândia", taubate: "Taubaté", jundiai: "Jundiaí", vitoria: "Vitória", paraiba: "Paraíba", grande: "Grande",
    aguas: "Águas", angelo: "Ângelo", antonio: "Antônio", sebastiao: "Sebastião", conceicao: "Conceição", ceara: "Ceará", para: "Pará", piaui: "Piauí" };
  function titulo(s) {
    return s.replace(/\S+/g, function (w) {
      var low = w.toLowerCase();
      if (ACENTOS[low]) return ACENTOS[low];
      return /^(de|da|do|das|dos|e)$/.test(low) ? low : low.charAt(0).toUpperCase() + low.slice(1);
    });
  }

  function Frete(data) {
    this.data = data;
    this.faixas = data.faixas; // ordenadas por CEP inicial, sem sobreposição
  }

  // busca binária da faixa que contém o CEP
  Frete.prototype.faixa = function (cep8) {
    var n = parseInt(cep8, 10), F = this.faixas, lo = 0, hi = F.length - 1;
    while (lo <= hi) {
      var mid = (lo + hi) >> 1, f = F[mid];
      if (n < f[0]) hi = mid - 1;
      else if (n > f[1]) lo = mid + 1;
      else return f;
    }
    return null;
  };

  // preço de um grupo para um peso em gramas
  Frete.prototype.preco = function (grupoIdx, pesoG) {
    var g = this.data.grupos[grupoIdx], pesos = this.data.pesos_g, faixas = g[0], adic = g[1];
    var p = Math.max(1, Math.ceil(pesoG || 0));
    for (var i = 0; i < pesos.length; i++) if (p <= pesos[i]) return faixas[i];
    var extraKg = Math.ceil((p - pesos[pesos.length - 1]) / 1000);
    return Math.round((faixas[faixas.length - 1] + extraKg * (adic || 0)) * 100) / 100;
  };

  /** calcular(cep, pesoG) -> { cep, localidade, uf, servicos: [{nome, preco, prazo}] } | { erro } */
  Frete.prototype.calcular = function (cep, pesoG) {
    var c = normalizaCep(cep);
    if (!c) return { erro: "cep_invalido" };
    var f = this.faixa(c);
    if (!f) return { erro: "cep_nao_atendido", cep: c };
    return {
      cep: c,
      localidade: titulo(f[2]),
      uf: f[3],
      servicos: [
        { nome: "PAC", preco: this.preco(f[4], pesoG), prazo: f[6] },
        { nome: "SEDEX", preco: this.preco(f[5], pesoG), prazo: f[7] }
      ]
    };
  };

  var cache = {};
  function load(url) {
    if (!cache[url]) {
      cache[url] = fetch(url, { credentials: "same-origin" })
        .then(function (r) { if (!r.ok) throw new Error("frete: HTTP " + r.status); return r.json(); })
        .then(function (d) { return new Frete(d); });
      // falha (rede, navegação no meio do download) sai do cache pra próxima tentativa baixar de novo;
      // o catch também evita "unhandled rejection" (no Safari/Instagram: "TypeError: Load failed")
      cache[url].catch(function () { delete cache[url]; });
    }
    return cache[url];
  }
  function fromData(data) { return new Frete(data); }

  /* ---------------- widget (design Claude Design, 22/09/2026) ---------------- */
  var ICON_HAND = '<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8 13V5.5a1.5 1.5 0 0 1 3 0V12"/><path d="M11 11.5v-2a1.5 1.5 0 0 1 3 0V12"/><path d="M14 10.5a1.5 1.5 0 0 1 3 0V12"/><path d="M17 11.5a1.5 1.5 0 0 1 3 0V16a6 6 0 0 1-6 6h-2a6 6 0 0 1-5-2.7L4.3 15a1.6 1.6 0 0 1 2.6-1.9L8 14.5"/></svg>';
  var ICON_BOX = '<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 8 12 3 3 8v8l9 5 9-5z"/><path d="M3 8l9 5 9-5"/><path d="M12 13v8"/></svg>';
  var ICON_TRUCK = '<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>';
  var MESES = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];
  function dataUtil(n) { // hoje + n dias úteis (sáb/dom), sem feriados
    var d = new Date(); d.setHours(12, 0, 0, 0);
    while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
    return d.getDate() + " " + MESES[d.getMonth()];
  }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

  var TEMPLATE =
    '<div class="kf-band">' +
    '  <span class="kf-band-icon"></span>' +
    '  <span class="kf-band-text"><span class="kf-band-title"></span><span class="kf-band-sub"></span></span>' +
    '</div>' +
    // estado inicial: anuncia o frete grátis; o formulário só aparece ao clicar no link
    '<div class="kf-intro" hidden>' +
    '  <span class="kf-intro-icon">' + ICON_TRUCK + '</span>' +
    '  <span class="kf-intro-text"><span class="kf-intro-main"></span>' +
    '    <span class="kf-intro-line"><span class="kf-intro-sub"></span><button class="kf-intro-cta" type="button" aria-expanded="false"></button></span></span>' +
    '</div>' +
    '<button class="kf-closed" type="button" hidden>' +
    '  <span class="kf-closed-icon">' + ICON_TRUCK + '</span>' +
    '  <span class="kf-closed-text"><span class="kf-closed-main"></span><span class="kf-closed-sub"></span></span>' +
    '  <span class="kf-closed-cta">Precisa antes?</span>' +
    '</button>' +
    '<div class="kf-open" hidden>' +
    '  <div class="kf-open-head"><span class="kf-open-title">Frete e prazo</span><button class="kf-close" type="button" hidden>Fechar</button></div>' +
    '  <div class="kf-field-wrap">' +
    '    <div class="kf-field">' +
    '      <input class="kf-input" id="kf-cep-__ID__" inputmode="numeric" autocomplete="postal-code" placeholder="00000-000" maxlength="9" aria-label="Seu CEP" aria-describedby="kf-help-__ID__">' +
    '      <button class="kf-btn" type="button"><span class="kf-spin" hidden></span><span class="kf-btn-label">Calcular</span></button>' +
    '    </div>' +
    '    <div class="kf-help-row"><span class="kf-help" id="kf-help-__ID__" role="status" aria-live="polite">Digite o CEP de entrega</span>' +
    '      <a class="kf-link" href="https://buscacepinter.correios.com.br/app/endereco/index.php" target="_blank" rel="noopener">Não sei meu CEP</a></div>' +
    '  </div>' +
    '  <div class="kf-methods" role="radiogroup" aria-label="Forma de envio" hidden></div>' +
    '  <div class="kf-timeline" hidden>' +
    '    <div class="kf-bar"><span class="kf-bar-build"></span><span class="kf-bar-ship"></span></div>' +
    '    <div class="kf-legend"><span><i class="kf-sw kf-sw--build"></i><span class="kf-legend-build"></span></span><span><i class="kf-sw kf-sw--ship"></i><span class="kf-legend-ship"></span></span></div>' +
    '    <span class="kf-foot"></span>' +
    '  </div>' +
    '</div>';

  var uid = 0;
  function mount(el, opts) {
    opts = opts || {};
    var id = ++uid;
    el.classList.add("kf");
    el.innerHTML = TEMPLATE.replace(/__ID__/g, id);
    var q = function (sel) { return el.querySelector(sel); };
    var band = q(".kf-band"), bandIcon = q(".kf-band-icon"), bandTitle = q(".kf-band-title"), bandSub = q(".kf-band-sub"),
        closed = q(".kf-closed"), closedMain = q(".kf-closed-main"), closedSub = q(".kf-closed-sub"),
        open = q(".kf-open"), closeBtn = q(".kf-close"), field = q(".kf-field"), input = q(".kf-input"), btn = q(".kf-btn"),
        spin = q(".kf-spin"), btnLabel = q(".kf-btn-label"), help = q(".kf-help"), methods = q(".kf-methods"),
        timeline = q(".kf-timeline"), barBuild = q(".kf-bar-build"), barShip = q(".kf-bar-ship"),
        legBuild = q(".kf-legend-build"), legShip = q(".kf-legend-ship"), foot = q(".kf-foot");

    // dados só são baixados quando o formulário abre (296 KB; a maioria dos visitantes nem calcula)
    var frete = function () { return opts.data ? Promise.resolve(fromData(opts.data)) : load(opts.dataUrl); };
    var fn = function (v, d) { return typeof v === "function" ? v() : (v == null ? d : v); };
    var peso = function () { return fn(opts.peso, 0) || 0; };
    var valor = function () { return fn(opts.valorPedido, 0) || 0; };
    var gratisAcima = opts.freteGratisAcima;
    var preparo = opts.diasPreparo == null ? 2 : opts.diasPreparo;
    var margem = opts.margem == null ? 0.05 : opts.margem;
    var extra = function () { return fn(opts.diasExtra, 0) || 0; };
    var aviso = function () { return fn(opts.avisoPrazo, null); };
    var comMargem = function (v) { return Math.ceil(v * (1 + margem) * 100) / 100; };
    var gratisPAC = function () { return gratisAcima != null && valor() >= gratisAcima; };
    var dias = function (n) { return n + (n === 1 ? " dia útil" : " dias úteis"); };
    var resultado = null, metodo = "PAC";

    // faixa superior: sempre visível
    var oficina = function () { return !!fn(opts.oficina, false); }; // montado/preparado pela Kuba → pode falar em "oficina"
    function renderBand() {
      var e = extra(), a = aviso(), ofi = oficina();
      el.classList.toggle("kf--encomenda", e > 0);
      if (a) {
        bandIcon.innerHTML = ofi ? ICON_HAND : ICON_BOX; bandTitle.textContent = a;
        bandSub.textContent = "Sai da Kuba em até " + dias(preparo + e) + " a partir da confirmação do pedido.";
      } else if (e > 0 && ofi) {
        bandIcon.innerHTML = ICON_HAND;
        bandTitle.innerHTML = (opts.textoEncomenda ? esc(opts.textoEncomenda) : 'Montado à mão <em>pra você</em>');
        bandSub.textContent = "Sua unidade só começa a ser montada quando você compra. Peça por peça, na nossa oficina no Brasil.";
      } else if (e > 0) {
        bandIcon.innerHTML = ICON_BOX;
        bandTitle.textContent = "Sob encomenda";
        bandSub.textContent = "Sai da Kuba em até " + dias(preparo + e) + " a partir da confirmação do pedido.";
      } else {
        bandIcon.innerHTML = ICON_BOX;
        bandTitle.textContent = "Pronta entrega";
        bandSub.textContent = (ofi ? "Sai da nossa oficina em até " : "Enviado em até ") + dias(preparo) + ".";
      }
    }

    var openTitle = q(".kf-open-title");
    var intro = q(".kf-intro"), introMain = q(".kf-intro-main"), introSub = q(".kf-intro-sub"), introCta = q(".kf-intro-cta");
    // pronta entrega (sem aviso nem dias extras): a faixa some no estado inicial e o prazo de envio vira o subtítulo
    var prontaEntrega = function () { return !aviso() && !(extra() > 0); };
    function renderIntro() {
      if (gratisPAC()) {
        introMain.innerHTML = '<b class="kf-gratis">Frete grátis</b> para todo o Brasil';
        introCta.textContent = "Calcular prazo de entrega ›";
      } else {
        introMain.innerHTML = gratisAcima != null
          ? '<b class="kf-gratis">Frete grátis</b> acima de R$ ' + String(gratisAcima).replace(".", ",")
          : "Entrega para todo o Brasil";
        introCta.textContent = "Calcular prazo de entrega ›";
      }
      introSub.textContent = prontaEntrega() ? (oficina() ? "Sai da nossa oficina em até " : "Enviado em até ") + dias(preparo) : "";
      introSub.hidden = !introSub.textContent;
      markWrap();
    }
    // se o link não couber na mesma linha do subtítulo (celular), tira o "·" que ficaria solto no fim da linha
    function markWrap() {
      if (intro.hidden || introSub.hidden) return;
      intro.classList.remove("kf-intro--wrap");
      if (introCta.getBoundingClientRect().top - introSub.getBoundingClientRect().top > 4) intro.classList.add("kf-intro--wrap");
    }
    window.addEventListener("resize", markWrap);
    window.addEventListener("load", markWrap); // fontes carregadas mudam a largura do texto
    function setView(v, foco) { // 'intro' | 'closed' | 'open'; foco só quando o usuário abre (evita teclado no mobile ao carregar)
      intro.hidden = v !== "intro"; closed.hidden = v !== "closed"; open.hidden = v !== "open";
      if (v === "open") frete(); // adianta o download enquanto o visitante digita o CEP
      band.hidden = v === "intro" && prontaEntrega();
      introCta.setAttribute("aria-expanded", v === "open" ? "true" : "false");
      openTitle.innerHTML = gratisPAC() ? '<b class="kf-gratis">Frete grátis</b> · calcular prazo' : "Frete e prazo";
      if (v === "intro") renderIntro();
      if (v === "open") closeBtn.hidden = false; // sempre dá pra voltar: pro resumo (se já calculou) ou pro estado inicial
      if (v === "open" && foco) setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) {} }, 0);
    }
    function setErro(msg) {
      field.classList.toggle("kf-field--erro", !!msg);
      help.classList.toggle("kf-help--erro", !!msg);
      if (msg) help.textContent = msg;
    }
    function setLoading(on) {
      btn.disabled = on; spin.hidden = !on; btnLabel.textContent = on ? "Calculando" : "Calcular";
    }

    function prazoTotal(s) { return s.prazo == null ? null : s.prazo + preparo + extra(); }

    function renderResultado(r) {
      resultado = r;
      var gratis = gratisPAC();
      help.textContent = "Entrega para " + r.localidade + ", " + r.uf;
      methods.innerHTML = "";
      r.servicos.forEach(function (s) {
        var d = prazoTotal(s), isGratis = gratis && s.nome === "PAC";
        var b = document.createElement("button");
        b.type = "button"; b.setAttribute("role", "radio"); b.className = "kf-method"; b.dataset.nome = s.nome;
        b.innerHTML = '<span class="kf-radio"><span></span></span>' +
          '<span class="kf-method-text"><span class="kf-method-name">' + s.nome + '</span>' +
          '<span class="kf-method-when">' + (d == null ? "prazo sob consulta" : "Chega até " + dataUtil(d) + " · " + dias(d)) + '</span></span>' +
          '<span class="kf-method-price' + (isGratis ? " kf-method-price--gratis" : "") + '">' + (isGratis ? "Grátis" : brl(comMargem(s.preco))) + '</span>';
        b.addEventListener("click", function () { metodo = s.nome; paint(); });
        methods.appendChild(b);
      });
      methods.hidden = false; timeline.hidden = false; closeBtn.hidden = false;
      paint();
      try { localStorage.setItem("kf-cep", r.cep); } catch (e) {}
      el.dispatchEvent(new CustomEvent("kuba-frete", { detail: r, bubbles: true }));
    }

    function paint() { // estado selecionado → radios, barra, linha fechada
      if (!resultado) return;
      var sel = null;
      resultado.servicos.forEach(function (s) { if (s.nome === metodo) sel = s; });
      if (!sel) { sel = resultado.servicos[0]; metodo = sel.nome; }
      methods.querySelectorAll(".kf-method").forEach(function (b) {
        var on = b.dataset.nome === metodo; b.classList.toggle("is-on", on); b.setAttribute("aria-checked", String(on));
      });
      var e = extra(), build = preparo + e, total = prazoTotal(sel), ship = total == null ? 0 : Math.max(0, total - build);
      var etapa = aviso() ? ["Produção", "a produção", "a"] : (e > 0 ? (oficina() ? ["Montagem na oficina", "a montagem", "a"] : ["Encomenda", "a encomenda", "a"]) : ["Preparo", "o preparo", "o"]);
      barBuild.style.flex = String(build); barShip.style.flex = String(ship || 1);
      legBuild.textContent = etapa[0] + " · até " + build + (build === 1 ? " dia" : " dias");
      legShip.textContent = "Transporte · " + ship + (ship === 1 ? " dia" : " dias");
      foot.textContent = "Prazos em dias úteis, já com " + etapa[1] + " incluíd" + etapa[2] + ". Estimativa: o valor final aparece no carrinho.";
      // linha fechada: frete grátis em primeiro lugar; as duas opções lado a lado
      var gratis = gratisPAC(), pac = null, sedex = null;
      resultado.servicos.forEach(function (s) { if (s.nome === "PAC") pac = s; if (s.nome === "SEDEX") sedex = s; });
      var dPac = pac ? prazoTotal(pac) : null, dSed = sedex ? prazoTotal(sedex) : null;
      q(".kf-closed-cta").textContent = (sedex && dSed != null && dPac != null && dSed < dPac) ? "Precisa antes?" : "Alterar";
      var ate = function (d) { return d == null ? "prazo sob consulta" : "até " + dataUtil(d); };
      if (gratis && pac) {
        closedMain.innerHTML = '<b class="kf-gratis">Frete grátis</b> · ' + (dPac == null ? "prazo sob consulta" : "chega " + esc(ate(dPac)));
        closedSub.textContent = resultado.localidade + ", " + resultado.uf + (e > 0 || aviso() ? " · prazo já inclui " + etapa[1] : "");
      } else {
        closedMain.innerHTML = (pac ? "PAC " + esc(brl(comMargem(pac.preco))) + " · chega " + esc(ate(dPac)) : "");
        var falta = gratisAcima != null && valor() > 0 ? gratisAcima - valor() : 0;
        closedSub.textContent = resultado.localidade + ", " + resultado.uf + (falta > 0 ? " · faltam " + brl(falta) + " pro frete grátis" : "") + (e > 0 || aviso() ? " · prazo já inclui " + etapa[1] : "");
      }
    }

    function calcular(silencioso) {
      var c = normalizaCep(input.value);
      if (!c) { setErro("Digite os 8 números do CEP."); return Promise.resolve(); }
      setErro(null);
      if (!silencioso) setLoading(true);
      return frete().then(function (f) {
        var r = f.calcular(c, peso());
        if (r.erro) { setErro("CEP não encontrado. Confere os 8 números?"); methods.hidden = true; timeline.hidden = true; if (silencioso) setView("open"); return; }
        renderResultado(r);
        if (silencioso) setView("closed");
      }).catch(function () { setErro("Não foi possível calcular agora. Tente de novo em instantes."); })
        .then(function () { setLoading(false); });
    }

    input.addEventListener("input", function () {
      var d = input.value.replace(/\D/g, "").slice(0, 8);
      input.value = d.length > 5 ? d.slice(0, 5) + "-" + d.slice(5) : d;
      if (field.classList.contains("kf-field--erro")) { setErro(null); help.textContent = "Digite o CEP de entrega"; }
    });
    input.addEventListener("keydown", function (ev) { if (ev.key === "Enter") { ev.preventDefault(); ev.stopPropagation(); calcular(false); } });
    btn.addEventListener("click", function () { calcular(false); });
    closed.addEventListener("click", function () { setView("open", true); });
    closeBtn.addEventListener("click", function () { setView(resultado ? "closed" : "intro"); });
    introCta.addEventListener("click", function () { setView("open", true); });

    // produto/variante esgotado → widget some (o tema mostra "esgotado" / avise-me)
    function visibilidade() { var ok = opts.disponivel == null ? true : !!fn(opts.disponivel, true); el.hidden = !ok; return ok; }
    visibilidade();
    renderBand();
    var prev = null; try { prev = opts.lembrarCep === false ? null : localStorage.getItem("kf-cep"); } catch (e) {}
    if (prev && normalizaCep(prev)) { input.value = prev.slice(0, 5) + "-" + prev.slice(5); setView("open"); calcular(true); }
    else setView("intro");

    return {
      recalcular: function () { if (!visibilidade()) return; renderBand(); if (!intro.hidden) { renderIntro(); band.hidden = prontaEntrega(); } if (normalizaCep(input.value)) calcular(!closed.hidden); },
      abrir: function () { setView("open", true); }, fechar: function () { if (resultado) setView("closed"); }
    };
  }

  root.KubaFrete = { load: load, fromData: fromData, mount: mount, formatar: brl, normalizaCep: normalizaCep };
})(typeof window !== "undefined" ? window : this);
